import { useState } from 'react'
import { FcGoogle } from 'react-icons/fc'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from '@mui/material'

import useDialogStyles from '../../hooks/useDialogStyles'
import PersistLoginAlert from './PersistLoginAlert'
import PersistLoginCheckbox from './PersistLoginCheckbox'

const SignInWithGoogleButton = ({ persist, setPersist, label = 'Continue with Google' }) => {
  const theme = useTheme()
  const { paperSx, titleSx, contentSx, actionsSx, goldButtonSx, cancelButtonSx } = useDialogStyles()
  const isDark = theme.palette.mode === 'dark'
  const [show, setShow] = useState(false)

  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL}/api/auth/google?persist=${persist}`
  }

  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        onClick={() => setShow(true)}
        startIcon={<FcGoogle size={18} />}
        sx={{
          height: 44,
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.9rem',
          color: theme.palette.text.primary,
          borderColor: isDark ? 'rgba(255,255,255,0.22)' : theme.palette.neutral[300],
          backgroundColor: isDark ? 'rgba(255,255,255,0.03)' : '#fff',
          '&:hover': {
            borderColor: isDark ? 'rgba(255,255,255,0.45)' : theme.palette.neutral[400],
            backgroundColor: isDark ? 'rgba(255,255,255,0.07)' : theme.palette.neutral[50],
          },
        }}
      >
        {label}
      </Button>

      <Dialog open={show} onClose={() => setShow(false)} maxWidth="xs" fullWidth PaperProps={{ sx: paperSx }}>
        <DialogTitle sx={{ ...titleSx, display: 'flex', alignItems: 'center', gap: 1 }}>
          <FcGoogle size={20} /> Continue with Google
        </DialogTitle>
        <DialogContent sx={contentSx}>
          <PersistLoginCheckbox persist={persist} setPersist={setPersist} bold />
          <Box sx={{ mt: 1.5 }}>
            <PersistLoginAlert />
          </Box>
        </DialogContent>
        <DialogActions sx={actionsSx}>
          <Button onClick={() => setShow(false)} sx={cancelButtonSx}>Cancel</Button>
          <Button variant="contained" onClick={handleLogin} sx={goldButtonSx}>Continue</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SignInWithGoogleButton
